import { createSelector } from '@reduxjs/toolkit';

interface UserProfile {
  attributes?: {
    [application: string]: {
      call_taker_mode_settings?: {
        workstation_position?: string;
      };
    };
  };
}

interface User {
  profile?: UserProfile;
  currentRole?: {
    application?: string;
  };
}

interface SinatraState {
  user: User;
}

interface RootState {
  sinatra: SinatraState;
}

/**
 * Resolves the workstation position from user profile attributes
 * @param {User} user - The user object from state
 * @param {string} application - The application name
 * @returns {string|undefined} The workstation position
 */
const resolveWorkstationPosition = (
  user: User,
  application?: string,
): string | undefined => {
  if (!application) {
    return undefined;
  }

  return user?.profile?.attributes?.[application]?.call_taker_mode_settings
    ?.workstation_position;
};

/**
 * Selector to return the workstation position for the current application
 * @param {RootState} state - The Redux state
 * @returns {string|undefined} The workstation position or undefined if not found
 */
export const workstationPositionSelector = createSelector(
  (state: RootState) => state.sinatra.user,
  (state: RootState) => state.sinatra.user.currentRole?.application,
  (user: User, application?: string) => {
    return resolveWorkstationPosition(user, application);
  },
);
